// import numeral from 'numeral';
// import strings from './strings';

export default function bootstrap() {
    //numeral.locale(strings.getInterfaceLanguage());
}



// WEBPACK FOOTER //
// ./app/bootstrap.js